import React from "react";

import { PropTypes } from "prop-types";

export const RadioGroup = ({
  options,
  onChange,
  value,
  name,
  onBlur,
  style,
}) => (
  <div style={style}>
    {options.map(option => (
      <div key={option.label} style={{ marginRight: 18 }}>
        <input
          style={{ marginRight: 6 }}
          name={name}
          type="radio"
          value={option.value}
          checked={option.value === value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {option.label}
      </div>
    ))}
  </div>
);

RadioGroup.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  style: PropTypes.object,
};
